import React, { useState } from 'react';

import CreateNewPi from '@features/order-cancel/CreateNewPi';
import RequestConfirmation from '@features/order-cancel/RequestConfirmation';

const OrderCancelBottomBar = ({ selectedRFQIds, setSelectedRFQIds }) => {
	const [openOrderCancelModal, setOpenOrderCancelModal] = useState(false);
	const [isCreateNewPi, setIsCreateNewPi] = useState(false);
	const [isAddNewPi, setIsAddNewPi] = useState(false);

	const onCloseModal = () => {
		setSelectedRFQIds([]);
		setOpenOrderCancelModal(false);
		setIsCreateNewPi(false);
		setIsAddNewPi(false);
	};

	return (
		<>
			{selectedRFQIds.length > 0 && (
				<div className="design-count-section cancel-style-count bg-white shadow-8dp">
					<div className="count-info d-flex justify-content-between align-items-center">
						<div className="design-count">
							<p className="semibold-18">{selectedRFQIds.length}</p>
						</div>
						<div className="buttons ">
							<button
								className="button text size36"
								onClick={() => setOpenOrderCancelModal(true)}
							>
								<span className="ml-1 red">Cancel Style</span>
							</button>
						</div>
						<div className="buttons ">
							<button className="button text size36" onClick={() => setIsCreateNewPi(true)}>
								<span className="ml-1">Create new PI</span>
							</button>
						</div>
						<div className="buttons ">
							<button className="button text size36" onClick={() => setIsAddNewPi(true)}>
								<span className="ml-1">Add to PI</span>
							</button>
						</div>
						<div
							className="text-right close-icon"
							onClick={() => {
								setSelectedRFQIds([]);
							}}
						>
							<img
								src={`${process.env.PUBLIC_URL}/icons/close.svg`}
								alt="close"
								className="cursor-pointer"
							/>
						</div>
					</div>
				</div>
			)}
			{openOrderCancelModal && (
				<RequestConfirmation
					onCloseModal={onCloseModal}
					rfqIdList={selectedRFQIds}
					requestedType={'PRODUCT'}
				/>
			)}
			{(isCreateNewPi || isAddNewPi) && (
				<CreateNewPi
					onCloseModal={onCloseModal}
					type={isCreateNewPi ? 'CREATE' : 'ADD'}
					rfqIdList={selectedRFQIds}
				/>
			)}
		</>
	);
};

export default OrderCancelBottomBar;
